import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/CDL-Atlantic_logo_white.png")